import { useState } from "react"
import { Row, Col, Form, Button, ButtonGroup } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import moment from "moment"

interface DateRangeFilterProps {
  onFilter: (startDate: string, endDate: string) => void
  loading?: boolean
}

const presets = [
  { key: "month", labelKey: "This Month", getRange: () => ({ start: moment().startOf("month").format("YYYY-MM-DD"), end: moment().format("YYYY-MM-DD") }) },
  { key: "quarter", labelKey: "Last Quarter", getRange: () => ({ start: moment().subtract(3, "months").startOf("month").format("YYYY-MM-DD"), end: moment().format("YYYY-MM-DD") }) },
  { key: "year", labelKey: "This Year", getRange: () => ({ start: moment().startOf("year").format("YYYY-MM-DD"), end: moment().format("YYYY-MM-DD") }) },
  { key: "12months", labelKey: "Last 12 Months", getRange: () => ({ start: moment().subtract(12, "months").format("YYYY-MM-DD"), end: moment().format("YYYY-MM-DD") }) },
]

export default function DateRangeFilter({ onFilter, loading }: DateRangeFilterProps) {
  const { t } = useTranslation("global")
  const [startDate, setStartDate] = useState(moment().startOf("month").format("YYYY-MM-DD"))
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"))
  const [activePreset, setActivePreset] = useState("month")

  const handlePreset = (key: string) => {
    const preset = presets.find(p => p.key === key)
    if (!preset) return
    const range = preset.getRange()
    setStartDate(range.start)
    setEndDate(range.end)
    setActivePreset(key)
    onFilter(range.start, range.end)
  }

  const handleGenerate = () => {
    setActivePreset("")
    onFilter(startDate, endDate)
  }

  return (
    <Row className="align-items-end g-2 mb-4">
      <Col xs={12} md="auto">
        <ButtonGroup size="sm">
          {presets.map(p => (
            <Button
              key={p.key}
              variant={activePreset === p.key ? "primary" : "outline-primary"}
              onClick={() => handlePreset(p.key)}
              disabled={loading}
            >
              {t(p.labelKey)}
            </Button>
          ))}
        </ButtonGroup>
      </Col>
      <Col xs={6} md={2}>
        <Form.Control
          type="date"
          size="sm"
          value={startDate}
          onChange={e => setStartDate(e.target.value)}
        />
      </Col>
      <Col xs={6} md={2}>
        <Form.Control
          type="date"
          size="sm"
          value={endDate}
          onChange={e => setEndDate(e.target.value)}
        />
      </Col>
      <Col xs={12} md="auto">
        <Button size="sm" variant="primary" onClick={handleGenerate} disabled={loading}>
          {loading ? <i className="fas fa-spinner fa-spin me-1" /> : <i className="fas fa-search me-1" />}
          {t("Generate")}
        </Button>
      </Col>
    </Row>
  )
}
